import React from 'react'
import withIcon from '@/components/withIcon'

const IconReading = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M23 30L15.944 31L9 30V19L15.944 20L23 19V30Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15.944 11C14.6179 11 13.3461 10.4732 12.4084 9.53553C11.4708 8.59785 10.944 7.32608 10.944 6C10.944 4.67392 11.4708 3.40215 12.4084 2.46447C13.3461 1.52678 14.6179 1 15.944 1C16.6006 1 17.2508 1.12933 17.8574 1.3806C18.464 1.63188 19.0152 2.00017 19.4795 2.46447C19.9438 2.92876 20.3121 3.47995 20.5634 4.08658C20.8146 4.69321 20.944 5.34339 20.944 6C20.944 7.32608 20.4172 8.59785 19.4795 9.53553C18.5418 10.4732 17.2701 11 15.944 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M13 25L3.02499 27.494C2.84196 27.5397 2.64974 27.5328 2.47051 27.4739C2.29128 27.415 2.13236 27.3066 2.01211 27.1613C1.89185 27.0159 1.81516 26.8395 1.7909 26.6524C1.76664 26.4654 1.79579 26.2752 1.87499 26.104L6.46399 16.162C6.62408 15.8151 6.88018 15.5213 7.20201 15.3154C7.52384 15.1094 7.89792 15 8.27999 15H23.715C24.0982 14.9999 24.4734 15.11 24.7959 15.3171C25.1184 15.5241 25.3746 15.8195 25.534 16.168L30.079 26.107C30.1574 26.2783 30.1858 26.4683 30.1609 26.6551C30.1361 26.8419 30.059 27.0178 29.9385 27.1627C29.818 27.3075 29.659 27.4154 29.4799 27.4738C29.3007 27.5323 29.1087 27.5389 28.926 27.493L19 25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default withIcon(IconReading)
